  import * as doT from 'doT';

function dig(obj, selector) {
    var result = obj;
    const splitter = selector.split('.');

    for (let i = 0; i < splitter.length; i++){
        if (result == undefined)
            return undefined;                
        result = result[splitter[i]];
    }
    if (typeof(result) === 'string' && (result.startsWith("http://") || result.startsWith("https://"))) {
        return `<a href="${result}" target="_blank">${result}</a>`;
    }
    else
        return result;
}

export function collect(obj, field) {
    //console.log(obj[field])
    if (obj[field])
        return obj[field];
    else
        return "";
}

export function exportExcel(columns, rows, title) {
    const mimeType = 'data:text/csv';
    const html = renderCSV(columns, rows);

    const documentPrefix = title
    const d = new Date();

    var dummy = document.createElement('a');
    dummy.href = mimeType + ', ' + html;
    dummy.download = documentPrefix
        + '-' + d.getFullYear() + '-' + (d.getMonth()+1) + '-' + d.getDate()
        + '-' + d.getHours() + '-' + d.getMinutes() + '-' + d.getSeconds()
        +'.csv';
    dummy.click();
}

export function exportSummary(columns, rows, title, template) {
    const mimeType = 'data:text/html';
    const html = renderSummary(columns, rows, template);

    const documentPrefix = title
    const d = new Date();

    var dummy = document.createElement('a');
    dummy.href = mimeType + ', ' + html;
    dummy.download = documentPrefix
        + '-' + d.getFullYear() + '-' + (d.getMonth()+1) + '-' + d.getDate()
        + '-' + d.getHours() + '-' + d.getMinutes() + '-' + d.getSeconds()
        +'.html';
    dummy.click();
}

function renderSummary(columns, rows, template) {
    var tempFn = doT.default.template(template.text);
    var result = "<html>";
    rows.map(function (row) {
        result = result + "<section id='" + row.muid_g + "' style='margin: 0 auto;width:850px'>";
        var feature = {
            properties: row
        }
        result = result + tempFn(feature);
        result = result + "</div>";
    })
    result = result + "</html>";
    return result;
}

export function print(columns, rows) {
    let win = window.open("");
    win.document.write(renderTable(columns, rows));
    win.print();
    win.close();
}

function renderTable(columns, rows) {
    let table = '<table><thead>';

    table += '<tr>';
    for (let i = 0; i < columns.length; i++) {
        const column = columns[i];
        table += '<th>';
        table += 	column.label;
        table += '</th>';
    }
    table += '</tr>';

    table += '</thead><tbody>';
    
    for (let i = 0; i < rows.length; i++) {
        const row = rows[i];
        table += '<tr>';
        for (let j = 0; j < columns.length; j++) {
            const column = columns[j];
            table += '<td>';
            table +=	collect(row, column.field);
            table += '</td>';
        }
        table += '</tr>';
    }

    table += '</tbody></table>';
    return table;
}

function renderTSV(columns, rows) {
    let table = '';
    for (let i = 0; i < columns.length; i++) {
        const column = columns[i];
        table += 	column.label;
        table += '\t';
    }
    table += '\r\n';
    
    for (let i = 0; i < rows.length; i++) {
        const row = rows[i];
        for (let j = 0; j < columns.length; j++) {
            const column = columns[j];
            table +=  collect(row, column.field);
            table += '\t';
        }
        table += '\r\n';
    }

    return table;
}

function renderCSV(columns, rows) {
    let table = '';
    for (let i = 0; i < columns.length; i++) {
        const column = columns[i];
        table += '"' + column.label + '"';
        table += ',';
    }
    table += '\r\n';
    
    for (let i = 0; i < rows.length; i++) {
        const row = rows[i];
        for (let j = 0; j < columns.length; j++) {
            const column = columns[j];
            table += '"' + collect(row, column.field) + '"';
            table += ',';
        }
        table += '\r\n';
    }

    return table;
}